import React from "react";
import { useNavigate } from "react-router-dom";

function AssessmentViewClickPopup({ setAssClick }) {
  const navigation = useNavigate();
  const closePopup = () => {
    setAssClick(false);
    navigation("/Assessment")
  };
  return (
    <div className="ContainerSubmitedSucess ">
      <div className="SubContainerSubmitedSucess" style={{ height: "200px" }}>
        <div className="d-flex justify-content-start gap-3 align-items-center">
          <img src="/StudentImg/BreathSchoolLogo.png" alt="icon"></img>
          <span className="sucessMsg20">Notice!</span>
        </div>
        <div className="mt-4 text-lg">
          <p>This is Upcoming Assessment.</p>
          <p>
            {"Please access it from 'Digital.Class' -> 'Assessment' screen."}
          </p>
        </div>
        {/* <div>Do you want to Start Assessment Now?</div> */}
        <div className="d-flex justify-content-around align-items-center mt-5 widthOfContainer">
          <button
            className="okayBtnsucess"
            onClick={() => {
              closePopup();
            }}
          >
            Redirect
          </button>
          <button
            className="okayBtnsucess"
            onClick={() => {
              setAssClick(false);
            }}
          >
            Go back
          </button>
        </div>
      </div>
    </div>
  );
}

export default AssessmentViewClickPopup;
